module.exports = __webpack_public_path__ + "img/face.dc04395b.svg";